<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <ContratSection />
</template>

<script setup lang="ts">
  import ContratSection from './sections/contrat/ContratSection.vue'
</script>
